module.exports = __webpack_public_path__ + "img/bike 1.b0873293.svg";